export default __webpack_public_path__ + "static/media/administrators.c05c8998.svg";